const en = {
    emailNotValid: 'Invalid email',
    passwordNotValid: 'Invalid password',
    passwordsNotMatched: 'Passwords do not match',
    password_rules:
        'The password must be at least 6 characters long and include at least one number, one special character, one uppercase letter, and one lowercase letter.',
    userExist: 'The entered email is already in use',
    socialLoginError: 'Error during login with {provider}',
    existingSocialLoginError: 'The user has already used another social login',
    password_policy_not_available: 'Error - Password policy not available',
};
export default en;
